/* eslint-disable import/prefer-default-export */
import {
  testimonialRandomFetch,
  testimonialsFetch,
  videoTestimonialRandomFetch,
  testimonialsRandomFetch
} from './'

export const testimonialsDispatchers = (dispatch) => ({
  loadRandomTestimonial() {
    dispatch(testimonialRandomFetch())
    dispatch(videoTestimonialRandomFetch())
  },
  loadTestimonials() {
    dispatch(testimonialsFetch())
  },
  loadRandomTestimonials() {
    dispatch(testimonialsRandomFetch())
  }
})
